import { useSelector } from 'react-redux';
import { selectActiveGlobalDiscount } from '../../slices/activeGlobalDiscountSlice';
import {
    buildSummaryNote,
    discountsForCompany,
    sharedDiscountReasonLabel,
    sharedMinimumPurchaseLabel,
    summaryValueLabel,
} from '../../utils/activeGlobalDiscount';

const ActiveGlobalDiscountLine = ({ companyRuc, appliedCode, amount = 0 }) => {
    const userInfo = useSelector((state) => state.auth.userInfo);
    const activeGlobalDiscount = useSelector(selectActiveGlobalDiscount);

    if (!userInfo || !companyRuc || Number(amount) > 0) {
        return null;
    }

    const discounts = discountsForCompany(activeGlobalDiscount, companyRuc);
    if (discounts.length === 0) {
        return null;
    }

    const valueLabel = summaryValueLabel(discounts);
    const minimumLabel = sharedMinimumPurchaseLabel(discounts);

    return (
        <div className="mb-1">
            <div className="d-flex justify-content-between align-items-center gap-2">
                <span className="small fw-semibold" style={{ color: '#b5430f' }}>
                    {sharedDiscountReasonLabel(discounts)}
                </span>
                {valueLabel ? (
                    <span className="small fw-semibold" style={{ color: '#b5430f' }}>
                        {valueLabel}
                    </span>
                ) : null}
            </div>
            <small className="text-muted d-block">
                {buildSummaryNote(discounts, appliedCode)}
            </small>
            {minimumLabel ? (
                <small className="text-muted d-block">Compra mínima de {minimumLabel}.</small>
            ) : null}
        </div>
    );
};

export default ActiveGlobalDiscountLine;
